export const FETCH_REFERABLE_ORDERS_REQUEST = "FETCH_REFERABLE_ORDERS_REQUEST";
export const FETCH_REFERABLE_ORDERS_SUCCESS = "FETCH_REFERABLE_ORDERS_SUCCESS";
export const FETCH_REFERABLE_ORDERS_FAILURE = "FETCH_REFERABLE_ORDERS_FAILURE";